import React, { useState } from "react";
import Desktop from "./Desktop";
import Mobile from "./Mobile";
import "./App.scss";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

function App() {
  const [windowDimensions] = useState(getWindowDimensions());

  if (windowDimensions.width < 600) {
    return <Mobile />;
  } else {
    return <Desktop />;
  }
}

export default App;
